import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface settlementState {
	isLoading: boolean;
	settlementList: any;
	totalsettlement: number;
	amountLoading: boolean;
}

const initialState: settlementState = {
	isLoading: false,
	settlementList: [],
	totalsettlement: 0,
	amountLoading: false
};

const settlementSlice = createSlice({
	name: 'settlements',
	initialState,
	reducers: {
		getsettlementListInit: state => {
			state.isLoading = true;
			state.settlementList = [];
			state.totalsettlement = 0;
		},
		getsettlementListSuccess: (state, action: PayloadAction<any>) => {
			state.isLoading = false;
			const data = action.payload.data;
			state.settlementList = [...data.finalResult];
			state.totalsettlement = data.count;
		},
		getsettlementListError: state => {
			state.isLoading = false;
			state.totalsettlement = 0;
			state.settlementList = [];
		},
		settlementAmountformInIt: state => {
			state.amountLoading = true;
		},
		settlementAmountformSuccess: state => {
			state.amountLoading = false;
		},
		settlementAmountformErrors: state => {
			state.amountLoading = false;
		}
	}
});

export const {
	getsettlementListError,
	getsettlementListInit,
	getsettlementListSuccess,
	settlementAmountformErrors,
	settlementAmountformInIt,
	settlementAmountformSuccess
} = settlementSlice.actions;

export default settlementSlice.reducer;
